module.exports = __webpack_public_path__ + "img/sensor.be6f6ffb.png";